import React, { useState, useEffect } from "react";
import { api } from "../api/axios";
import {
  fetchOrders,
  addDeliveryOrder,
  editOrderByID,
} from "../utils/fetchOrders";
import {
  Select,
  Input,
  Divider,
  DatePicker,
  Table,
  Button,
  message,
} from "antd";
import { fromDatetoYearMonthDay } from "../utils/utils";
import dayjs from "dayjs";
import { CheckOutlined } from "@ant-design/icons";
import { comunas } from "./OrderDetails";

const { TextArea } = Input;

const DEBUG = process.env.ENV === "development";

const Reschedule = () => {
  const [deliveryDate, setDeliveryDate] = useState(null);
  const [orders, setOrders] = useState([]);
  const [reeschedulingOrders, setReeschedulingOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingOrders, setLoadingOrders] = useState({});
  const [selectedOrder, setSelectedOrder] = useState(null);
  const handleDeliveryDateChange = (date) => {
    setOrders([]);
    setReeschedulingOrders([]);
    setDeliveryDate(date);
  };

  const handleRescheduleDateChange = (value, record) => {
    const updatedOrders = reeschedulingOrders.map((order) => {
      if (order.order_id === record.order_id) {
        return { ...order, rescheduleDate: value };
      }
      return order;
    });
    setReeschedulingOrders(updatedOrders);
  };

  const handleObservationChange = (value, record) => {
    const updatedOrders = reeschedulingOrders.map((order) => {
      if (order.order_id === record.order_id) {
        return { ...order, observation: value };
      }
      return order;
    });
    setReeschedulingOrders(updatedOrders);
  };

  const handleDailyIdChange = (value, record) => {
    const newReeschedulingOrders = reeschedulingOrders.map((order) => {
      if (order.order_id === record.order_id) {
        return { ...order, daily_id: value };
      }
      return order;
    });
    setReeschedulingOrders(newReeschedulingOrders);
  };

  const handleAddressChange = (value, record) => {
    const newReeschedulingOrders = reeschedulingOrders.map((order) => {
      if (order.order_id === record.order_id) {
        return { ...order, address: value };
      }
      return order;
    });
    setReeschedulingOrders(newReeschedulingOrders);
  };

  const handleCityChange = (value, record) => {
    const newReeschedulingOrders = reeschedulingOrders.map((order) => {
      if (order.order_id === record.order_id) {
        return { ...order, city: value };
      }
      return order;
    });
    setReeschedulingOrders(newReeschedulingOrders);
  };

  const handleSelectOrders = (value) => {
    const order = orders.find((order) => order.daily_id === value);

    // If Sunday, add 2, if not, add 1
    const addDays = new Date(deliveryDate).getDay() == 6 ? 2 : 1;
    console.log("delivery Date", deliveryDate);
    console.log("delivery Date", new Date(deliveryDate));
    console.log("day", new Date(deliveryDate).getDay());
    console.log("addDays", addDays);

    const newOrder = {
      ...order,
      rescheduleDate: dayjs(deliveryDate).add(addDays, "day"),
      observation:
        "Reagendado, llamar antes de ir. " +
        order.delivery_info_array[order.delivery_info_array.length - 1]
          .delivery_note,
      checked: false,
    };
    const newReeschedulingOrders = [...reeschedulingOrders, newOrder];
    setReeschedulingOrders(newReeschedulingOrders);
    const newOrders = orders.map((order) => {
      if (newReeschedulingOrders.some((o) => o.order_id === order.order_id)) {
        return { ...order, suggested: false };
      }
      return order;
    });
    setOrders(newOrders);
    // Reset value from the select
    setTimeout(() => {
      setSelectedOrder(null);
    }, 0);
  };

  const handleReschedule = async (record) => {
    // Set loading state for this specific order
    setLoadingOrders((prev) => ({ ...prev, [record.order_id]: true }));

    const newDailyId = record.daily_id;
    const newDate = record.rescheduleDate;
    const driverId = 0; // No asignado
    const deliveryStatus = "Por entregar";
    const deliveryNote = record.observation;
    const orderId = record.order_id;

    const orderData = {
      order_id: orderId,
      daily_id: newDailyId,
      name: record.name,
      address: record.address,
      amount: record.amount,
      city: record.city,
      seller_id: record.seller_id,
      order_type: record.order_type,
    };

    try {
      await editOrderByID(orderData);
    } catch (error) {
      if (DEBUG) console.log("error", error);
      message.error("Error al reagendar el pedido");
    }

    const data = {
      order_id: orderId,
      delivery_date: newDate,
      delivery_status: deliveryStatus,
      delivery_note: deliveryNote,
      driver_id: driverId,
    };

    console.log("data", data);

    try {
      await addDeliveryOrder(data);
      message.success("Pedido reagendado correctamente");
      // Put a checkmark in the order from the rescheduling list after successful reschedule
      setReeschedulingOrders((prev) =>
        prev.map((order) =>
          order.order_id === record.order_id
            ? { ...order, checked: true }
            : order,
        ),
      );
    } catch (error) {
      if (DEBUG) console.log("error", error);
      message.error("Error al reagendar el pedido");
    } finally {
      // Clear loading state for this specific order
      setLoadingOrders((prev) => ({ ...prev, [record.order_id]: false }));
    }
  };

  const handleDelete = (record) => {
    const newReeschedulingOrders = reeschedulingOrders.filter(
      (order) => order.order_id !== record.order_id,
    );
    setReeschedulingOrders(newReeschedulingOrders);
    const newOrders = orders.map((order) => {
      if (newReeschedulingOrders.some((o) => o.order_id === order.order_id)) {
        return { ...order, suggested: true };
      }
      return order;
    });
    console.log("newOrders", newOrders);
    setOrders(newOrders);
  };

  const columns = [
    {
      title: "Daily ID",
      dataIndex: "daily_id",
      key: "daily_id",
      width: 150,
      render: (_, record) => (
        <Input
          value={record.daily_id}
          onChange={(e) => handleDailyIdChange(e.target.value, record)}
          disabled={record.checked || loadingOrders[record.order_id]}
        />
      ),
    },
    {
      title: "Dirección",
      dataIndex: "address",
      key: "address",
      width: 300,
      render: (_, record) => (
        <Input
          value={record.address}
          onChange={(e) => handleAddressChange(e.target.value, record)}
          disabled={record.checked || loadingOrders[record.order_id]}
        />
      ),
    },
    {
      title: "Comuna",
      dataIndex: "city",
      key: "city",
      width: 100,
      render: (_, record) => (
        <Select
          value={record.city}
          onChange={(value) => handleCityChange(value, record)}
          options={comunas.map((comuna) => ({
            label: comuna,
            value: comuna,
          }))}
          showSearch
          disabled={record.checked || loadingOrders[record.order_id]}
        />
      ),
    },
    {
      title: "Productos",
      dataIndex: "products",
      key: "products",
      width: 300,
      render: (products) =>
        products?.map((p) => `${p.quantity}x ${p.product_name}`).join(", ") ||
        "",
    },
    {
      title: "Número de entregas",
      dataIndex: "delivery_info_array",
      key: "deliveries",
      width: 100,
      render: (deliveries) => deliveries?.length || 0,
    },
    {
      title: "Fecha de reagendamiento",
      key: "rescheduleDate",
      width: 200,
      render: (_, record) => (
        <DatePicker
          value={record.rescheduleDate}
          onChange={(date) => handleRescheduleDateChange(date, record)}
          disabled={record.checked || loadingOrders[record.order_id]}
        />
      ),
    },
    {
      title: "Observación",
      key: "observation",
      width: 400,
      render: (_, record) => (
        <TextArea
          value={record.observation}
          onChange={(e) => handleObservationChange(e.target.value, record)}
          placeholder="Add observation"
          autoSize={{ minRows: 2, maxRows: 6 }}
          disabled={record.checked || loadingOrders[record.order_id]}
        />
      ),
    },
    {
      title: "Acción",
      key: "action",
      width: 120,
      render: (_, record) =>
        record.checked ? (
          <CheckOutlined />
        ) : (
          <Button
            type="primary"
            onClick={() => handleReschedule(record)}
            loading={loadingOrders[record.order_id]}
          >
            Reagendar
          </Button>
        ),
    },
    {
      title: "Cancelar",
      key: "cancel",
      width: 120,
      render: (_, record) => (
        <Button
          type="default"
          onClick={() => handleDelete(record)}
          // loading={loadingOrders[record.order_id]}
          disabled={record.checked || loadingOrders[record.order_id]}
        >
          Cancelar
        </Button>
      ),
    },
  ];

  // Everytime the delivery date changes, fetch the orders
  useEffect(() => {
    if (DEBUG) console.log("deliveryDate", deliveryDate);
    const fetchData = async () => {
      if (deliveryDate) {
        const shortDate = fromDatetoYearMonthDay(new Date(deliveryDate));
        const data = await fetchOrders("", shortDate);
        const orders = data.map((order) => ({
          ...order,
          suggested: true,
        }));
        setOrders(orders);
      }
    };
    fetchData();
  }, [deliveryDate]);

  return (
    <div>
      <div className="font-bold text-3xl">Re-agendar Pedidos</div>
      <div>
        Selecciona una fecha de entrega y una fecha a la cual deseas reagendar.
      </div>
      <Divider />
      <div className="flex flex-col gap-2">
        <div>
          <h2 className="text-lg">Selecciona la fecha de entrega</h2>
          <div className="mt-2">
            Fecha de entrega: <DatePicker onChange={handleDeliveryDateChange} />
          </div>
        </div>
        <div>
          {deliveryDate &&
            orders.length === 0 &&
            ordersLoadingMessage["loading"]}
        </div>

        {orders.length > 0 && deliveryDate && (
          <div>
            <h2 className="text-lg">Selecciona los pedidos a reagendar</h2>
            <div className="mt-2">
              <Select
                className="w-full"
                showSearch
                placeholder="Selecciona los pedidos"
                onSelect={handleSelectOrders}
                value={selectedOrder}
                options={orders
                  .filter((order) => order.suggested)
                  .map((order) => ({
                    key: `order-${order.order_id}`,
                    label: order.daily_id + " - " + order.name,
                    value: order.daily_id,
                  }))}
              />
            </div>
          </div>
        )}

        <div>
          <h2 className="text-lg">Lista de pedidos seleccionados</h2>
          <div className="mt-2">
            {orders.length > 0 && deliveryDate && (
              <Table
                columns={columns}
                dataSource={reeschedulingOrders}
                rowKey="order_id"
                pagination={false}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reschedule;

const ordersLoadingMessage = {
  loading: "Cargando pedidos...",
  error: "Error al cargar los pedidos",
  noOrders: "No hay pedidos para reagendar",
};
